import { useTranslation } from "@shared/utils/internationalization";
import Link from "@ui-kit/navigation/Link/Link.web";
import CDNImage from "@ui-kit/media/CDNImage/CDNImage.web";
import type { AppleAppStoreLinkSharedProps } from "./AppleAppStoreLink.props";

export default function AppleAppStoreLink(
  props: AppleAppStoreLinkProps
): JSX.Element {
  const { t, i18n } = useTranslation("common");
  const {
    className,
    onClick,
    lang,
    width = "element.7xl",
    height = "element.5xl",
  } = props;

  const locale = lang || i18n.language;

  return (
    <Link
      {...(width && { width })}
      {...(height && { height })}
      position="relative"
      display="inline-block"
      fontSize="sm"
      borderRadius="xs"
      mr="xs"
      onClick={onClick}
      external
      target="_blank"
      href="https://apps.apple.com/ca/app/showpass/id1422040696"
      className={className}
    >
      <CDNImage
        useServerlessResize={false}
        src={`images/logos/${locale || "en"}/apple-app-store.png`}
        alt={t("Download on Apple App Store")}
        fill
        style={{ objectFit: "contain" }}
      />
    </Link>
  );
}

export type AppleAppStoreLinkProps = AppleAppStoreLinkSharedProps & {
  // Add any web specific props here.
};
